//import React components
import {Button} from "reactstrap";

//import components
//import icons
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useSettingStore} from "../../../../context/settings";
import shallow from "zustand/shallow";
import {useConfigStore} from "../../../../context/configs";

//Props settings for MenuButton


export default function MenuButton() {
  const {navbarExtended, toggleNavbar} = useSettingStore((state) => ({
      toggleNavbar: state.toggleNavbar,
      navbarExtended: state.navbarExtended,
    }),
    shallow
  );

  const {setAllNavGroups, setConfig, prevNavGroup} = useConfigStore((state) => ({
    setAllNavGroups: state.setAllNavGroups,
    prevNavGroup: state.prevNavGroups,
    setConfig: state.setConfig,
  }), shallow);

  return (
    <>
      <Button
        title={navbarExtended ? "Minimer sidemeny" : "Åpne sidemeny"}
        color={"blank"}
        className={"nav-menuBtn"}
        onClick={() => {
          if (navbarExtended) {
            setAllNavGroups(false, true);
          } else {
            setConfig("navGroups", prevNavGroup);
          }
          toggleNavbar();
        }}
      >
        <FontAwesomeIcon icon={["fas", "bars"]}/>
      </Button>
    </>
  )
}
